import { acceptStringValue } from '../../field-viewer/shared-normalizers';
import { resolveDefaultDateValue } from './date-picker-default-value';
export const datePickerViewer = {
    resolveDefault: resolveDefaultDateValue,
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map